import React from "react";
import styles from "./index.less";
import getLocalizedTime from "../utils/timeType";

export default function StatementExamIDID() {
  return (
    <div className={styles["declaration"]}>
      <h1>Pernyataan Kepatuhan untuk Pelatihan dan Ujian Anggota Tim Lapangan</h1>

      <p>
        Dalam rangka meningkatkan kualitas layanan para promotor pihak ketiga di lapangan, Tim Pelatihan Departemen Internasional Xiaomi (selanjutnya disebut "kami" atau "perusahaan kami") menyelenggarakan program pelatihan beserta ujian penguatan materi bagi para promotor pihak ketiga (selanjutnya disebut "peserta pelatihan") yang ditunjuk oleh penyedia layanan outsourcing. Tujuan pelatihan dan ujian adalah untuk mengoptimalkan materi pelatihan serta memperkuat pemahaman peserta pelatihan, dan tidak dimaksudkan untuk membentuk hubungan kerja atau tindakan kepengurusan apa pun. Berikut ini adalah pernyataan mengenai pelatihan dan ujian tersebut:
      </p>

      <ol>
        <li>
          <strong>Sifat Pelatihan dan Ujian</strong><br/>
          Seluruh pelatihan dan ujian dilakukan untuk berbagi pengetahuan, membantu peserta pelatihan memahami secara sistematis informasi produk, standar layanan, dan materi terkait lainnya. Hasil ujian hanya mencerminkan tingkat pemahaman peserta pelatihan terhadap materi pelatihan, tidak menjadi dasar untuk penilaian kinerja. Kami tidak memiliki kewenangan dan tidak akan ikut campur dalam penilaian kinerja, pembagian gaji, atau urusan hubungan kerja lainnya antara peserta pelatihan dan penyedia layanan outsourcing.
        </li>
        <li>
          <strong>Klarifikasi Hubungan Hukum</strong><br/>
          Hubungan kerja antara peserta pelatihan dan penyedia layanan outsourcing tetap sepenuhnya berada di bawah kewenangan penyedia layanan tersebut. Tidak ada hubungan kerja antara perusahaan kami dengan peserta pelatihan, dan pelatihan serta ujian ini tidak membentuk hubungan kerja secara de facto.
        </li>
        <li>
          <strong>Penggunaan Hasil Ujian</strong><br/>
          Hasil ujian hanya akan digunakan untuk tujuan berikut:
          <ol type="1">
            <li>Menjadi referensi internal bagi perusahaan untuk mengoptimalkan dan meningkatkan materi pelatihan internal perusahaan kami;</li>
            <li>Diberikan kepada penyedia layanan outsourcing sebagai bukti kompetensi profesional peserta pelatihan, tunduk pada penilaian independen dan kesediaan penyedia layanan outsourcing;</li>
            <li>Tidak akan dipublikasikan atau diungkapkan kepada pihak ketiga manapun.</li>
          </ol>
        </li>
      </ol>

      <p>
        Pernyataan ini berlaku sejak tanggal diterbitkan. Partisipasi dalam program pelatihan dan ujian berarti peserta pelatihan memahami dan menyetujui isi pernyataan ini. Perusahaan kami memiliki hak penuh untuk interpretasi akhir serta melakukan perubahan yang wajar terhadap pernyataan ini.
      </p>

      <div className={styles["footer"]}>
        Tim Pelatihan Departemen Internasional Xiaomi<br/>
        Tanggal: {getLocalizedTime('id-ID')}
      </div>
    </div>
  );
}